import React from "react";
import { Container, ContainerFW } from "../global";
import { getContainerClassPerMaxWidth, } from "../../utils";
import { CardWithImageAndText, } from "./CardWithImageAndText";
import { ButtonV2 } from "../ButtonV2";
import { Swiper, SwiperSlide } from "swiper/react";
export const M41SwiperCardDeckTitleSubtitleButton = ({ cards, buttonProps, title, subtitle, titleColor, subtitleColor, containerMaxWidth = "1128px", backgroundColor, }) => {
    const containerMaxWidthClass = containerMaxWidth && getContainerClassPerMaxWidth(containerMaxWidth);
    const hasButton = (() => buttonProps.url && buttonProps.text)();
    return (React.createElement(ContainerFW, { className: containerMaxWidthClass, backgroundColor: backgroundColor },
        React.createElement(Container, { className: containerMaxWidthClass },
            React.createElement("div", { className: "swiper-card-deck-title-subtitle-btn", style: {
                    "--title-color": titleColor,
                    "--subtitle-color": subtitleColor,
                } },
                title && (React.createElement("h2", { className: "swiper-card-deck-title-subtitle-btn__title", dangerouslySetInnerHTML: { __html: title } })),
                subtitle && (React.createElement("div", { className: "swiper-card-deck-title-subtitle-btn__subtitle", dangerouslySetInnerHTML: { __html: subtitle } })),
                React.createElement("div", { className: "swiper-card-deck-title-subtitle-btn__cards" },
                    React.createElement(Swiper, { breakpoints: {
                            375: {
                                slidesPerView: 1.2,
                                spaceBetween: 24,
                            },
                            601: {
                                slidesPerView: 2.2,
                                spaceBetween: 24,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 24,
                            },
                        } }, Array.isArray(cards) &&
                        cards.map((card, index) => (React.createElement(SwiperSlide, { key: index },
                            React.createElement(CardWithImageAndText, { imgSrc: card.imgSrc, text: card.text, backgroundColor: card.backgroundColor, linkUrl: card.linkUrl, linkOpenInNewTab: card.linkOpenInNewTab })))))),
                hasButton && (React.createElement(Button, { url: buttonProps.url, text: buttonProps.text, openInNewTab: buttonProps.openInNewTab, design: buttonProps.design }))))));
};
const Button = ({ url, text, openInNewTab, design = "ghost-medium-wbg", }) => (React.createElement(ButtonV2, { href: url, openInNewTab: openInNewTab, design: design }, text));
